import src from "IMAGE";
export default { src, width: 309, height: 90, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AJ+CIIV+ahtpZVUWUWBRGUiykh+WOE8rVAlhWHQJVU1kAGlYGFSAbR1nZVYVTXRiGVmvkRuWN1s4YApFP1AHNzI/xmoUVZE65sUAAAAASUVORK5CYII="};
